import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { QA_NAME_CHATROOM_MESSAGE_EDITED } from '../Chatroom.constants'

import { getChatroomMessageEditedTooltipText } from './ChatroomMessageEditedMarker.utils'

import * as styles from './ChatroomMessageEditedMarker.module.css'

function ChatroomMessageEditedMarker({
  className = styles.chatroomMessageEditedMarker,
  editedAt,
}) {
  const { t } = useTranslation()

  const timeZone = useTimeZone()

  return (
    <FloatingTooltip
      content={getChatroomMessageEditedTooltipText({ editedAt, t, timeZone })}
    >
      <Text
        isSecondary
        className={className}
        qaName={QA_NAME_CHATROOM_MESSAGE_EDITED}
      >
        {t('Chatroom.MessageEditedMarkerKey')}
      </Text>
    </FloatingTooltip>
  )
}

export default ChatroomMessageEditedMarker
